module.exports = __webpack_public_path__ + "static/img/env01.293d88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env01.png
// module id = 98
// module chunks = 4